import React from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@material-ui/core'
import IconFactory from 'shared/icons/IconFactory/IconFactory'
import { useStyles } from './PipedriveFormModal_style'

const PipedriveFormModal = ({ open, onClose, url }) => {
    const classes = useStyles()

    return (
        <Dialog open={open} onClose={onClose} maxWidth='md' PaperProps={{ className: classes.dialogContainer }}>
            <DialogTitle disableTypography className={classes.dialogTitle}>
                <Box display='flex' alignItems='center' justifyContent='flex-end'>
                    <IconButton onClick={onClose} aria-label='close'>
                        <IconFactory icon='close' />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.pipedriveFormContainer}>
                    <iframe
                        src={url}
                        className={classes.iframe}
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                        sandbox='allow-forms allow-same-origin allow-scripts'
                    />
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default PipedriveFormModal
